import request from '@/utils/request'

//获取全部分会名称，用于下拉框搜索
export function getAllAgent(data) {
    return request({
        url: '/backend/agent/getAllAgent',
        method: 'post',
        data: data
    })
}

//获取所有分会列表
export function getAgentList(data) {
    return request({
        url: '/backend/agent/message/send/list',
        method: 'post',
        data: data
    })
}

export function getProvinceCityList(data) {
    return request({
        url: '/backend/agent/province/city/list',
        method: 'post',
        data: data
    })
}